import { securedAxiosInstance } from "../axios";
import { toCamelCase } from "@estaly/ui";

class GrossSalesService {
  async importFile(organizationId, file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("organization_id", organizationId);
    const response = await securedAxiosInstance.post("/gross_sales/import", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return toCamelCase(response);
  }
}

export default new GrossSalesService();
